<template>
  <div>
    <table class="table">
      <tr>
        <th>Название</th>
        <th>Цена</th>
        <th>Удалить</th>
      </tr>
      <table-editable-item
        v-for="item in list"
        :key="item.id"
        :item="item"
        @deleteItem="deleteItem"
      />
    </table>

    <div class="row">
      <button class="btn btn-block" type="button" @click="addItem">
        Добавить позицию
      </button>
      <button class="btn btn-block" type="button" @click="saveList">
        Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import TableEditableItem from "@/components/Table-editable-item";
import CALC from "@/utils/calc";
import firebase from "firebase";

export default {
  name: "Table-editable",
  components: { TableEditableItem },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      list: [
        // {
        //   id: CALC.generateID(),
        //   name: "jacob",
        //   price: "31"
        // },
        // {
        //   id: CALC.generateID(),
        //   name: "Kortni",
        //   price: "24"
        // }
      ]
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    addItem() {
      this.list.push({
        id: CALC.generateID(),
        name: "",
        price: ""
      });
    },
    loadList() {
      return firebase
        .database()
        .ref(`goods/${this.name}`)
        .once("value")
        .then(res => {
          this.list = res.val() ?? [];
        });
    },
    saveList() {
      firebase
        .database()
        .ref(`goods/${this.name}`)
        .set(this.list)
        .then(() => {
          alert("save");
        });
    },
    deleteItem(id) {
      this.list = this.list.filter(item => item.id !== id);
    }
  }
};
</script>

<style lang="scss" scoped>
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
}
</style>
